module.exports = __webpack_public_path__ + "static/img/2-1-search.8f5cbc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/2-1-search.png
// module id = 1313
// module chunks = 0